'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var ES5Type = require("../5/Type"); // https://www.ecma-international.org/ecma-262/6.0/#sec-tostring


module.exports = function Type(x) {
  if (_typeof(x) === 'symbol') {
    return 'Symbol';
  }

  return ES5Type(x);
};